import { AfterViewInit, ChangeDetectorRef, Component, Input, NgZone, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AppService } from '@core/services/app.service';
import { TranslocoService } from '@ngneat/transloco';
import { Application } from '@shared/models/Application';
import { Breadcrumb } from '@shared/models/Breadcrumb';
import { filter } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent implements AfterViewInit, OnDestroy {
  @Input() application!: Application;
  navItems: Breadcrumb[] = [];
  private navItemsTimeout: any;

  constructor(
    private readonly router: Router,
    private readonly appService: AppService,
    private readonly translateService: TranslocoService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly ngZone: NgZone
  ) {}

  ngAfterViewInit() {
    this.appService.application = this.application;
    this.updateNavItems();
    this.router.events
      .pipe(
        filter(
          (event): event is NavigationEnd => event instanceof NavigationEnd
        )
      )
      .subscribe(() => {
        this.updateNavItems();
      });

    this.appService.languageSubject.subscribe(() => {
      this.updateNavItems();
    });
  }

  private updateNavItems() {
    clearTimeout(this.navItemsTimeout);
    this.navItemsTimeout = this.ngZone.runOutsideAngular(() => {
      return setTimeout(() => {
        this.navItems = this.appService.getMenuItems();
        this.cdRef.detectChanges();
      }, 0);
    });
  }

  ngOnDestroy() {
    clearTimeout(this.navItemsTimeout);
  }

  onItemSelect(navItem: string, index: number, isHome: boolean) {
    this.navItems = this.navItems.map((item, elementIndex) => {
      item.isSelected = elementIndex === index ? true : false;
      return item;
    });
    this.router.navigate([navItem]);
  }
}
